// Builds the single payload sent to /o/game-guest/add-campaign-game-results
// — called exactly once, by the final Result screen, with the CyberIsland
// totals accumulated (via AddModuleAnswers/AddGameTime) across every module.
export const CYBER_ISLAND_GAME_ID = "NDdBL213RDA1bzlUeGhTM3owZFhTdz09";

export const getPrGameAttendeeId = (props) =>
  (props.prGameAttendeeId &&
    props.prGameAttendeeId.data &&
    props.prGameAttendeeId.data.prGameAttendeeId) ||
  null;

export const getPrGameAttendeeAttemptId = (props) =>
  (props.prGameAttendeeAttemptId &&
    props.prGameAttendeeAttemptId.data &&
    props.prGameAttendeeAttemptId.data.prGameAttendeeAttemptId) ||
  null;

export const buildCampaignResult = ({
  prGameAttendeeId,
  prGameAttendeeAttemptId,
  correct,
  wrong,
  timeSpentInSeconds,
}) => {
  const total = correct + wrong;
  const scorePercent = total > 0 ? (correct / total) * 100 : 0;

  return {
    prGameAttendeeId: prGameAttendeeId || null,
    prGameAttendeeAttemptId: prGameAttendeeAttemptId || null,
    phishrodGameId: CYBER_ISLAND_GAME_ID,
    moduleResults: {
      moduleName: "CyberIsland",
      totalQuestions: total,
      correctAnswers: correct,
      scorePercent: scorePercent,
      timeSpentInSeconds: timeSpentInSeconds || 0,
    },
  };
};
